import {dataTestId} from '@hconnect/uikit'
import {
  LinearProgress,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Skeleton,
  Stack
} from '@mui/material'
import {ReactNode} from 'react'

export type ListData<T> = {
  id: T
  title: string | null
  label: string
}

type StateListProps<T> = {
  data?: ListData<T>[]
  isLoading: boolean
  isFetching: boolean
  secondaryAction?: (item: ListData<T>) => ReactNode
  onClick?: (id: T) => void
  'data-test-id': string
}

export const StateList = <T,>({
  isFetching,
  isLoading,
  data,
  secondaryAction,
  onClick,
  'data-test-id': testId
}: StateListProps<T>) => {
  return (
    <Stack>
      {isFetching && !isLoading ? <LinearProgress /> : <div style={{height: '4px'}}></div>}
      <List sx={{maxHeight: 'calc(100vh - 300px)', overflow: 'auto'}}>
        {!isLoading &&
          data?.map((item, index) => (
            <ListItem
              key={`list-item-${item.id}`}
              disablePadding
              secondaryAction={secondaryAction?.(item)}
              divider={index !== data.length - 1}
              {...dataTestId(`${testId}-${item.id}`)}
            >
              {onClick ? (
                <ListItemButton sx={{px: 3}} onClick={() => onClick(item.id)}>
                  <ListItemText primary={item.title} secondary={item.label} />
                </ListItemButton>
              ) : (
                <ListItemText sx={{px: 2, py: 1}} primary={item.title} secondary={item.label} />
              )}
            </ListItem>
          ))}

        {isLoading && (
          <Stack sx={{px: 3, py: 2}} spacing={2}>
            {Array(10)
              .fill(0)
              .map((_, i) => (
                <Stack
                  key={`skeleton-${i}`}
                  justifyContent="space-between"
                  alignItems="center"
                  direction="row"
                  spacing={2}
                >
                  <Skeleton variant="rounded" height={42} width={350} />
                  <Skeleton variant="circular" height={25} width={25} />
                </Stack>
              ))}
          </Stack>
        )}
      </List>
    </Stack>
  )
}
